import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import { FormActions } from '../../components';
import { FORM_REPORT_BIOMETHANE_PRODUCTION } from '../../constants/formKeys';
import { Button } from 'antd';
import { getRole } from '../../reducers/userReducer';
import { isAdmin } from '../../utils/roles';
import * as actions from '../../actions/actionCreators/reportGoActionCreators';
import { withRouter } from 'react-router-dom';

import { links } from '../../utils';
import { calcInitialDates } from '../GoReport/BaseGoReport';
import {
  filterFieldRenderer,
  getFilteredFormParams,
  renderFilterRows,
} from '../../utils/formHelpers';
import { formValueSelector } from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';

export class BiomethaneProductionReport extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isUserAdmin: PropTypes.bool.isRequired,
    formValues: PropTypes.object,
    initialValues: PropTypes.object,
  };

  state = {
    filter: true,
    loading: false,
    monthFilter: true,
    detailModalVisible: false,
    goReportDetails: {},
  };

  renderPeriodSelector = () => {
    const { t } = this.props;
    const { monthFilter } = this.state;
    return filterFieldRenderer({ t, monthFilter });
  };

  getXlsUrl() {
    const { formValues } = this.props;
    const { monthFilter } = this.state;
    const params = getFilteredFormParams(formValues, monthFilter);
    const paramString = new URLSearchParams(params);
    return links.reportProductionBiomethaneXls + '?' + paramString.toString();
  }

  renderFirstRows(monthFilter, t) {
    return renderFilterRows({
      monthFilter,
      t,
      onChange: (e) => this.setState({ monthFilter: e.target.value }),
      monthLabelKey: 'goReport.filterModeGroup.monthModeProduction',
      rangeLabelKey: 'goReport.filterModeGroup.rangeModeProduction',
      secondRowContent: this.renderPeriodSelector(),
    });
  }

  render() {
    const { t, initialValues } = this.props;
    const { monthFilter } = this.state;

    return (
      <div>
        <Form
          initialValues={initialValues}
          onSubmit={() => {}}
          render={() => {
            return (
              <form>
                <FormStateToRedux form={FORM_REPORT_BIOMETHANE_PRODUCTION} />
                {this.renderFirstRows(monthFilter, t)}
                <FormActions>
                  <a href={this.getXlsUrl()} rel="noopener noreferrer">
                    <Button>{t('goReport.generateXls')}</Button>
                  </a>
                </FormActions>
              </form>
            );
          }}
        />
      </div>
    );
  }
}

const selector = formValueSelector(FORM_REPORT_BIOMETHANE_PRODUCTION);

const mapStateToProps = (state) => ({
  isUserAdmin: isAdmin(getRole(state)),
  initialValues: calcInitialDates(),
  formValues: selector(state),
});

const mapDispatchToProps = {
  fetchReportGoItemsPage: actions.fetchBiomethaneReportGoItemsPage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BiomethaneProductionReport));
